const custom_en = require('./custom.json')
export default custom_en